import { useState, useEffect } from 'react';
import { apiClient, LookupData } from '../service/apiService';

type ActiveOptions = LookupData["activeOptions"];

interface UseLookupDataReturn extends ActiveOptions {
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useLookupData(): UseLookupDataReturn {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<ActiveOptions>({
    industries: [],
    regions: [],
    localities: [],
    ats_systems: [],
  });

  const fetchData = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const lookupData = await apiClient.getAllLookups();
      setData(lookupData.activeOptions);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch lookup data';
      setError(errorMessage);
      console.error('Error fetching lookup data:', err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    ...data,
    isLoading,
    error,
    refetch: fetchData,
  };
}